/**
 * 🌐 تنها منبع آدرس‌های محیطی admin-panel (API / سوکت / وب‌سایت).
 *
 * قانون: هیچ‌جای src نباید آدرس بک‌اند (localhost:3001 / api.gamizo.ir / tapi.gamizo.ir)
 * را هاردکد کند — همه از این ماژول import می‌کنند. `scripts/check-env-hardcodes.js`
 * قبل از هر بیلد این قانون را چک می‌کند.
 *
 * مقادیر از env می‌آیند:
 *   - بیلد:  env-profiles/<profile>.env → .env.production.local   (npm run build / build:test / build:local)
 *   - dev:   env-profiles/local.env     → .env.development.local  (npm start)
 * اگر env ست نشده باشد پیش‌فرض = پروداکشن (عمداً هیچ آدرس لوکالی اینجا نیست).
 */

const stripSlash = (s: string) => s.replace(/\/+$/, '');

const DEFAULT_API = 'https://api.gamizo.ir/api';
const DEFAULT_WEB = 'https://gamizo.ir';

/** آدرس را طوری نرمالایز می‌کند که همیشه به «/api» ختم شود. */
export function withApiSuffix(raw?: string | null): string {
  const base = stripSlash(raw || DEFAULT_API);
  return /\/api$/.test(base) ? base : `${base}/api`;
}

/** آدرس کامل API بک‌اند، همیشه با «/api» در انتها. */
export const API_BASE_URL: string = withApiSuffix(process.env.REACT_APP_API_URL);

/** origin بک‌اند بدون «/api» (برای /media، /uploads، سوکت و …). */
export const API_ORIGIN: string = API_BASE_URL.replace(/\/api$/, '');

/** آدرس Socket.IO — پیش‌فرض همان origin بک‌اند. */
export const SOCKET_URL: string = stripSlash(process.env.REACT_APP_SOCKET_URL || API_ORIGIN);

/** دامنهٔ عمومی وب‌سایت (لینک‌های «مشاهده در سایت»). */
export const WEB_BASE_URL: string = stripSlash(process.env.REACT_APP_WEB_BASE_URL || DEFAULT_WEB);
